import { render, staticRenderFns } from "./PagamentoFornecedorCanceladoRead.vue?vue&type=template&id=4d71d358&"
import script from "./PagamentoFornecedorCanceladoRead.vue?vue&type=script&lang=js&"
export * from "./PagamentoFornecedorCanceladoRead.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoFornecedorCanceladoRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports